import { createContext } from "react";
import { IAuthContext } from "./interfaces";

const AuthContext = createContext<IAuthContext>({
  havePermission: () => false,
  haveModule: () => false,
});

export default AuthContext;
